import { createTheme, Theme } from '@material-ui/core';
import colors from 'assets/jss/colors';
import color from 'color';
import numeral from 'numeral';
import constants from '../../config/constants';

const defaultFont = {
  fontFamily: '"Arial", sans-serif',
  color: colors.textPrimaryColor.hex(),
  letterSpacing: 0
};

interface IAppThemeFonts {
  odudoSanSerif: string;
}

const appThemeFonts: IAppThemeFonts = {
  odudoSanSerif: '"odudo", sans-serif'
};
const theme: Theme = createTheme({
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: { xs: 0, lg: 992, sm: 576, xl: 1300, md: 769 }
  },
  mixins: {
    toolbar: {
      minHeight: 56,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48
      },
      '@media (min-width:600px)': { minHeight: 64 }
    }
  },
  shadows: [
    'none',
    '0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
    '0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    '0px 1px 8px 0px rgba(0, 0, 0, 0.2),0px 3px 4px 0px rgba(0, 0, 0, 0.14),0px 3px 3px -2px rgba(0, 0, 0, 0.12)',
    '0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    '0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 5px 8px 0px rgba(0, 0, 0, 0.14),0px 1px 14px 0px rgba(0, 0, 0, 0.12)',
    '0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px 0px rgba(0, 0, 0, 0.14),0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    '0px 4px 5px -2px rgba(0, 0, 0, 0.2),0px 7px 10px 1px rgba(0, 0, 0, 0.14),0px 2px 16px 1px rgba(0, 0, 0, 0.12)',
    '0px 5px 5px -3px rgba(0, 0, 0, 0.2),0px 8px 10px 1px rgba(0, 0, 0, 0.14),0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
    '0px 5px 6px -3px rgba(0, 0, 0, 0.2),0px 9px 12px 1px rgba(0, 0, 0, 0.14),0px 3px 16px 2px rgba(0, 0, 0, 0.12)',
    '0px 6px 6px -3px rgba(0, 0, 0, 0.2),0px 10px 14px 1px rgba(0, 0, 0, 0.14),0px 4px 18px 3px rgba(0, 0, 0, 0.12)',
    '0px 6px 7px -4px rgba(0, 0, 0, 0.2),0px 11px 15px 1px rgba(0, 0, 0, 0.14),0px 4px 20px 3px rgba(0, 0, 0, 0.12)',
    '0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 12px 17px 2px rgba(0, 0, 0, 0.14),0px 5px 22px 4px rgba(0, 0, 0, 0.12)',
    '0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px 4px rgba(0, 0, 0, 0.12)',
    '0px 7px 9px -4px rgba(0, 0, 0, 0.2),0px 14px 21px 2px rgba(0, 0, 0, 0.14),0px 5px 26px 4px rgba(0, 0, 0, 0.12)',
    '0px 8px 9px -5px rgba(0, 0, 0, 0.2),0px 15px 22px 2px rgba(0, 0, 0, 0.14),0px 6px 28px 5px rgba(0, 0, 0, 0.12)',
    '0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
    '0px 8px 11px -5px rgba(0, 0, 0, 0.2),0px 17px 26px 2px rgba(0, 0, 0, 0.14),0px 6px 32px 5px rgba(0, 0, 0, 0.12)',
    '0px 9px 11px -5px rgba(0, 0, 0, 0.2),0px 18px 28px 2px rgba(0, 0, 0, 0.14),0px 7px 34px 6px rgba(0, 0, 0, 0.12)',
    '0px 9px 12px -6px rgba(0, 0, 0, 0.2),0px 19px 29px 2px rgba(0, 0, 0, 0.14),0px 7px 36px 6px rgba(0, 0, 0, 0.12)',
    '0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 20px 31px 3px rgba(0, 0, 0, 0.14),0px 8px 38px 7px rgba(0, 0, 0, 0.12)',
    '0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 21px 33px 3px rgba(0, 0, 0, 0.14),0px 8px 40px 7px rgba(0, 0, 0, 0.12)',
    '0px 10px 14px -6px rgba(0, 0, 0, 0.2),0px 22px 35px 3px rgba(0, 0, 0, 0.14),0px 8px 42px 7px rgba(0, 0, 0, 0.12)',
    '0px 11px 14px -7px rgba(0, 0, 0, 0.2),0px 23px 36px 3px rgba(0, 0, 0, 0.14),0px 9px 44px 8px rgba(0, 0, 0, 0.12)',
    '0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14),0px 9px 46px 8px rgba(0, 0, 0, 0.12)'
  ],
  direction: 'ltr',
  overrides: {
    MuiIcon: {
      colorPrimary: { color: colors.secondaryColor.hex() },
      colorAction: { color: colors.midnight.hex() }

    },
    MuiLink: {
      underlineHover: {
        '&:hover': {
          textDecoration: 'underline !important'
        }
      }
    },
    MuiButtonBase: {
      root: {
        '&:hover': {
          backgroundColor: 'inherit'
        },
        '&:focus': {
          outline: 'none !important',
          boxShadow: 'none !important'
        }
      }
    },
    MuiButton: {
      root: {
        textTransform: 'capitalize',
        '&:hover': {
          backgroundColor: 'inherit'
        },
        '&:focus': {
          outline: 'none !important'
        }
      },
      contained: {
        background: colors.white.hex(),
        boxShadow: 'none !important'
      },
      containedPrimary: {
        color: colors.white.hex(),
        backgroundColor: colors.secondaryColor.hex(),
        border: `1px solid ${colors.white.hex()}`,
        '&.Mui-disabled': {
          color: '#919EAB',
          borderColor: '#dfe3e8',
          background: '#dfe3e8'
        }
      },
      containedSecondary: {
        color: colors.white.hex(),
        '&.Mui-disabled': {
          color: colors.textPrimaryColor.hex(),
          opacity: 0.5
        }

      },
      textPrimary: {
        color: colors.secondaryColor.hex()
      }
    },
    MuiInputBase: {
      input: {
        color: 'rgba(0, 0, 0, 1)'
      }
    },
    MuiInput: {
      underline: {
        '&:hover:not(.Mui-disabled):before,&:before, &:after': {
          borderBottom: 'none !important'
        }
      }
    },
    MuiSelect: {
      icon: {
        right: '15px'
      }
    },
    MuiFormLabel: {
      root: {
        color: 'rgba(12, 19, 26, 0.7)',
        '&.Mui-focused': {
          color: colors.primaryColor.hex()
        },
        '&.Mui-disabled': {
          color: 'rgba(12, 19, 26, 0.7)'
        },
        '&.Mui-error': {
          color: colors.dangerColor.hex()
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: colors.white.hex(),
        borderRadius: 0,
        '&.Mui-focused': {
          backgroundColor: colors.white.hex()
        }
      }
    },
    MuiCheckbox: {
      root: {
        color: colors.primaryColor.hex()
      },
      colorPrimary: {
        '&.Mui-checked': {
          color: colors.primaryColor.hex()
        }
      }
    },
    MuiSlider: {
      root: {
        color: colors.primaryColor.hex()
      }
    },
    MuiTypography: {
      root: {
        color: 'red'
      },
      colorPrimary: {
        color: colors.secondaryColor.hex()
      }
    },
    MuiDialog: {
      root: {
        '& .MuiTypography-body2': {
          // color: '#454f5b !important'
        }
      },
      paperFullWidth: {
        width: 'calc(100% - 64px)'
      }
    }
  },
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
    },
    duration: {
      standard: 300,
      short: 250,
      enteringScreen: 225,
      shorter: 200,
      leavingScreen: 195,
      shortest: 150,
      complex: 375
    }
  },
  typography: {
    fontSize: 14,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    fontWeightLight: 300,
    fontFamily: '"Arial", sans-serif',
    button: {
      ...defaultFont,
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '16px',
      textTransform: 'capitalize'
    },
    h1: {
      ...defaultFont,
      fontFamily: appThemeFonts.odudoSanSerif,
      fontWeight: 'bold',
      fontSize: '32px',
      color: colors.textPrimaryColor.hex()
    },
    h2: {
      ...defaultFont,
      fontFamily: appThemeFonts.odudoSanSerif,
      fontWeight: 'bold',
      fontSize: '26px',
      color: colors.midnight.hex()
    },
    h3: {
      ...defaultFont,
      fontFamily: appThemeFonts.odudoSanSerif,
      fontWeight: 'bold',
      fontSize: '22px',
      color: colors.textPrimaryColor.hex()
    },
    h4: {
      ...defaultFont,
      fontFamily: appThemeFonts.odudoSanSerif,
      fontWeight: 'bold',
      fontSize: '32px',
      color: colors.textPrimaryColor.hex()
    },
    h5: {
      ...defaultFont,
      fontFamily: appThemeFonts.odudoSanSerif,
      fontWeight: 'bold',
      fontSize: '26px',
      color: colors.midnight.hex()
    },
    h6: {
      ...defaultFont,
      fontFamily: appThemeFonts.odudoSanSerif,
      fontWeight: 'bold',
      fontSize: '22px',
      color: colors.textPrimaryColor.hex()
    },
    subtitle1: {
      ...defaultFont,
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '24px'
    },
    subtitle2: {
      ...defaultFont,
      fontSize: '13.82px',
      fontWeight: 'bold',
      lineHeight: '24px'
    },
    body1: {
      ...defaultFont,
      fontSize: '16px'
    },
    body2: {
      ...defaultFont,
      fontSize: '13.8px'
    },
    caption: {
      ...defaultFont,
      fontWeight: 400,
      fontSize: '11.85px',
      lineHeight: '16px',
      letterSpacing: 0.4,
      color: colors.midnight.hex()
    },
    overline: {
      ...defaultFont,
      fontWeight: 'bold',
      fontSize: '11.85px',
      lineHeight: '16px',
      letterSpacing: 2,
      color: colors.midnight.hex()
    }
  },
  zIndex: {
    modal: 1300,
    snackbar: 1400,
    drawer: 1200,
    appBar: 1100,
    mobileStepper: 1000,
    tooltip: 1500
  },
  shape: { borderRadius: 4 },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  },
  spacing: 8,
  palette: {
    tonalOffset: 0.2,
    background: { paper: '#fff', default: '#F5F5F5' },
    contrastThreshold: 3,
    grey: {
      '50': '#fafafa',
      '100': '#f5f5f5',
      '200': '#eeeeee',
      '300': '#e0e0e0',
      '400': '#bdbdbd',
      '500': '#9e9e9e',
      '600': '#757575',
      '700': '#616161',
      '800': '#424242',
      '900': '#212121',
      A700: '#616161',
      A100: '#d5d5d5',
      A400: '#303030',
      A200: '#aaaaaa'
    },
    text: {
      primary: colors.textPrimaryColor.hex(),
      secondary: colors.textSecondaryColor.hex(),
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)'
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    secondary: {
      main: colors.secondaryColor.hex()
    },
    common: { black: '#000000', white: '#ffffff' },
    error: {
      main: colors.dangerColor.hex()
    },
    type: 'light',
    action: {
      hoverOpacity: 0.08,
      hover: 'rgba(0, 0, 0, 0.08)',
      selected: 'rgba(0, 0, 0, 0.14)',
      disabledBackground: 'rgba(0, 0, 0, 0.12)',
      disabled: 'rgba(0, 0, 0, 0.26)',
      active: 'rgba(0, 0, 0, 0.54)'
    },
    primary: {
      main: colors.primaryColor.hex(),
      dark: colors.primaryColorHover.hex()
    }
  }
});

declare global {
  // tslint:disable-next-line:interface-name
  interface String {
    toColorObject(): color;

    getHighEmphasis(): string;

    getMediumEmphasis(): string;

    getGradientStartColor(): string;

    getGradientEndColor(): string;

    getLowEmphasis(): string;

    getWithAlpha(alpha: number): string;

    darken(ratio: number): string;

    lighten(ratio: number): string;
  }

  // tslint:disable-next-line:interface-name
  interface Number {
    toPointsFormat(): string;
    toPointsFormatWithUnit(): string;
    toPointsFormatWithLowerCaseUnit(): string;
    getPointsUnit(): string;
    getPtsUnit(): string;
    toCurrencyFormat(): string;
  }
}

Number.prototype.toPointsFormat = function(): string {
  return numeral(this).format(constants.POINTS_FORMAT);
};

Number.prototype.toPointsFormatWithUnit = function(): string {
  return `${this.toPointsFormat()} ${this.getPointsUnit()}`;
};

Number.prototype.toPointsFormatWithLowerCaseUnit = function(): string {
  return this.toPointsFormatWithUnit().toLowerCase();
};

Number.prototype.getPointsUnit = function(): string {
  return `Point${this.valueOf() !== 1 ? 's' : ''}`;
};

Number.prototype.getPtsUnit = function(): string {
  return `Pt${this.valueOf() !== 1 ? 's' : ''}`;
};

Number.prototype.toCurrencyFormat = function(): string {
  return numeral(this).format(constants.CURRENCY_FORMAT);
};

String.prototype.toColorObject = function(): color {
  const value: string = this.toString();
  return color(value);
};

String.prototype.getHighEmphasis = function(): string {
  return this.toColorObject()
    .alpha(0.87)
    .rgb()
    .string();
};
String.prototype.getMediumEmphasis = function(): string {
  return this.toColorObject()
    .alpha(0.66)
    .rgb()
    .string();
};
String.prototype.getLowEmphasis = function(): string {
  return this.toColorObject()
    .alpha(0.2)
    .rgb()
    .string();
};
String.prototype.getGradientStartColor = function(): string {
  return this.toColorObject()
    .alpha(0.4)
    .rgb()
    .string();
};
String.prototype.getGradientEndColor = function(): string {
  return this.toColorObject()
    .alpha(0)
    .rgb()
    .string();
};

String.prototype.getWithAlpha = function(alpha: number): string {
  return this.toColorObject()
    .alpha(alpha)
    .rgb()
    .string();
};

String.prototype.darken = function(ratio): string {
  return this.toColorObject()
    .darken(ratio)
    .rgb()
    .string();
};

String.prototype.lighten = function(ratio): string {
  return this.toColorObject()
    .lighten(ratio)
    .rgb()
    .string();
};

const getTheme = (): Theme => theme;

export default getTheme;

